module.exports = __webpack_public_path__ + "static/media/subtract-circle-icon.dc7ed3ae.svg";